import { CircularProgress, useTheme } from '@mui/material';

import { StatusIcon as StatusIconMap } from '@/constants/icons';

import { ColorExtractFn } from '@/types/components/common';

import { getDataTestId } from '@/utils/browser';

import { IconName } from '../Icon';
import { Icon } from '../Icon/Icon';

import { StatusIconContainer } from './DataDisplay.styled';

export type StatusIconProps = {
  className?: string;
  value: string;
  iconName?: IconName;
  size?: number;
  isLoading?: boolean;
  color?: ColorExtractFn;
  backgroundColor?: ColorExtractFn;
  borderColor?: ColorExtractFn;
};

export function StatusIcon({
  className,
  value,
  iconName,
  size,
  isLoading,
  color: colorFn,
  backgroundColor: backgroundColorFn,
  borderColor: borderColorFn,
}: StatusIconProps) {
  const theme = useTheme();

  const icon = iconName || StatusIconMap[value] || 'question-circle';

  const color = isLoading
    ? theme.palette.grey[700]
    : colorFn
      ? colorFn(theme)
      : theme.palette.status[value]
        ? theme.palette.status[value].icon
        : theme.palette.grey[700];
  const backgroundColor = isLoading
    ? theme.palette.grey[200]
    : backgroundColorFn
      ? backgroundColorFn(theme)
      : theme.palette.status[value]
        ? theme.palette.status[value].iconBackground
        : theme.palette.grey[200];
  const borderColor = borderColorFn
    ? borderColorFn(theme)
    : theme.palette.status[value]
      ? theme.palette.status[value].iconBorder
      : undefined;

  return (
    <StatusIconContainer
      {...getDataTestId(`status-icon`)}
      iconColor={color}
      bgColor={backgroundColor}
      borderColor={borderColor}
      className={className}
      size={size}
    >
      {isLoading ? <CircularProgress size={20} /> : <Icon name={icon} />}
    </StatusIconContainer>
  );
}
